import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type SecurityDeprecatedPageEntryPointComponent = EntryPointComponent<{}, {}, {}, {}>;

export const securityDeprecatedPageEntryPoint: EntryPoint<
	SecurityDeprecatedPageEntryPointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForUserVisible<SecurityDeprecatedPageEntryPointComponent>(
		/* webpackChunkName: "async-security-deprecated-page" */ '@jira/software__security-page/src/SecurityDeprecatedPage.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: () => ({}),
});
